import React from 'react'
import PropTypes from 'prop-types'
import shallowCompare from 'react-addons-shallow-compare'
import {Table, Column, Cell} from 'components/Table'
import Touchpoints from './Touchpoints'
import OrderItems from './OrderItems'
import CustomerIcon from 'components/CustomerIcon'
import ConversionIcon from 'components/ConversionIcon'
import Link from 'components/Link'
import Limit from 'containers/Limit'
import NumberFormat from 'components/NumberFormat'
import copyToClipboard from 'copy-to-clipboard'
import WithTooltip from 'components/WithTooltip'
import classnames from 'classnames'

export default class OrdersTable extends React.Component {
  static propTypes = {
    orders: PropTypes.array,
    loading: PropTypes.bool,
    selectedTouchpoints: PropTypes.object,
    filters: PropTypes.object,
    limitedIds: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      hoveredGroup: null
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const touchpointsChanged =
      this.props.selectedTouchpoints === nextProps.selectedTouchpoints
    const filtersChanged = this.props.filters === nextProps.filters
    this._shouldRowUpdate = touchpointsChanged || filtersChanged
    return shallowCompare(this, nextProps, nextState)
  }

  render() {
    const {orders, loading, limitedIds} = this.props

    const classNames = classnames('orders-table_shadow', {
      'with-limitation': limitedIds
    })

    return (
      <div className={classNames}>
        <Table
          className='orders-table'
          data={orders}
          empty='No conversions could be found for the selected filters or time period.'
          loading={loading}
          onRowOver={this.onRowOver}
          onRowOut={this.onRowOut}
          shouldRowUpdate={() => this._shouldRowUpdate}
          loadingRows={30}
          hover
        >
          <Column
            header='Customer ID'
            cell={this.renderOrderId}
            width='120px'
          />
          <Column
            header='Last Conversion time'
            cell={this.renderDate}
            width='160px'
          />
          <Column
            header={
              <Cell>
                <Limit limitKey='orderExplorer' inline>
                  Customer Journey
                </Limit>
                <div className='orders-table_journey'>
                  <WithTooltip
                    title={'Impression'}
                    style='blue'
                    place='top'
                    align='start'
                  >
                    <div className='orders-table_journey_impresion'>
                      <div className='orders-table_journey_impresion_icon' />
                      <span>Post - view</span>
                    </div>
                  </WithTooltip>
                  <WithTooltip
                    title={'Visit'}
                    style='blue'
                    place='top'
                    align='start'
                  >
                    <div className='orders-table_journey_visit'>
                      <div className='orders-table_journey_visit_icon' />
                      <span>Post-Click</span>
                    </div>
                  </WithTooltip>
                  <WithTooltip
                    title={'Conversion Type'}
                    style='blue'
                    place='top'
                    align='start'
                  >
                    <div className='orders-table_journey_conversion'>
                      <ConversionIcon
                        name={'other'}
                        size={"28px"}
                      />
                      <span>Conversion Type</span>
                    </div>
                  </WithTooltip>
                </div>
              </Cell>
            }
            cell={this.renderTouchPoints}
            grow
          />
          <Column
            header={<Cell align='right'>Value</Cell>}
            cell={this.renderAmount}
            width='120px'
          />
          {/* <Column
            header='Products'
            cell={this.renderOrderItems}
            width='100px'
          />
          <Column
            header='Customer'
            cell={this.renderCustomer}
            width='100px'
          /> */}
        </Table>
      </div>
    )
  }

  renderUpgrade() {
    const {limitedIds} = this.props

    if (!limitedIds) return null

    return (
      <div className='orders-table_upgrade'>
        To view your full conversion history
        <Link
          className='orders-table_upgrade_button button is-blue'
          to='/settings'
        >
          Upgrade Now
        </Link>
      </div>
    )
  }

  renderOrderId(order) {
    return <OrderIdCell id={order.id} />
  }

  renderOrderItems(data) {
    const {orderItems = []} = data

    return (
      <Cell align='center'>
        <OrderItems items={orderItems} />
      </Cell>
    )
  }

  renderCustomer(data) {
    const {customer = {}} = data

    return (
      <CustomerCell
        isNew={customer.isNew}
        date={customer.createdAt}
        info={customer.info}
      />
    )
  }

  renderTouchPoints = data => {
    const {limitedIds} = this.props
    const limited = limitedIds && !limitedIds.includes(data.id)
    console.log('renderTouchPoints')

    return (
      <Cell>
        {limited ? this.renderUpgrade() : null}
        <Touchpoints
          disabled={limited}
          items={data.touchpoints || []}
        />
      </Cell>
    )
  }

  renderDate = data => {
    return <Cell format='datetime'>{data.date}</Cell>
  }

  renderAmount = data => {
    return <AmountCell currency={data.currency} amount={data.amount} />
  }

  onRowOver = data => {
    this.setState({
      selectedOrderId: data.id
    })
  }

  onRowOut = () => {
    this.setState({selectedOrderId: null})
  }

  isTouchpointSelected({channelGroup, channel}) {
    const {selectedTouchpoints} = this.props

    if (!selectedTouchpoints) return true

    const selectedGroup = selectedTouchpoints[channelGroup]

    if (!selectedGroup) return false
    if (Object.keys(selectedGroup).length === 0) return true

    return selectedGroup[channel]
  }
}

class CustomerCell extends React.Component {
  static propTypes = {
    isNew: PropTypes.bool,
    date: PropTypes.string,
    info: PropTypes.object
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  render() {
    const {isNew, info, ...restProps} = this.props

    return (
      <Cell align='center' className='orders-table_customer' {...restProps}>
        <CustomerIcon
          isNew={isNew}
          className='orders-table_customer-icon'
          info={info}
        />
      </Cell>
    )
  }
}

class OrderIdCell extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  constructor(props) {
    super(props)
    this.state = {copied: false}
  }

  render() {
    const {id} = this.props
    const {copied} = this.state

    return (
      <Cell className='orders-table_cell-order-id'>
        <WithTooltip
          title={copied ? 'copied' : `${id} (click to copy)`}
          style='blue'
          place='top'
          align='start'
        >
          <span
            className='orders-table_order-id'
            onClick={() => this.copyToClipboard(id)}
            onMouseEnter={() => this.setState({copied: false})}
          >
            {id}
          </span>
        </WithTooltip>
      </Cell>
    )
  }

  copyToClipboard = id => {
    this.setState({copied: true})
    copyToClipboard(id)
  }
}

class AmountCell extends React.Component {
  static propTypes = {
    currency: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  render() {
    const {currency, amount, ...restProps} = this.props

    return (
      <Cell {...restProps} align='right'>
        {amount !== null ? (
          <NumberFormat value={amount} format='currency' currency={currency} />
        ) : (
          '-'
        )}
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/OrdersTable.js